import React from "react";

const Printing = ({ color = "#000000", size = "20" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 6V4.2C17 3.0799 17 2.51984 16.782 2.09202C16.5903 1.71569 16.2843 1.40973 15.908 1.21799C15.4802 1 14.9201 1 13.8 1H8.2C7.07989 1 6.51984 1 6.09202 1.21799C5.71569 1.40973 5.40973 1.71569 5.21799 2.09202C5 2.51984 5 3.07989 5 4.2V6M5 17C4.07003 17 3.60504 17 3.22354 16.8978C2.18827 16.6204 1.37962 15.8117 1.10222 14.7765C1 14.395 1 13.93 1 13V10.8C1 9.11984 1 8.27976 1.32698 7.63803C1.6146 7.07354 2.07354 6.6146 2.63803 6.32698C3.27976 6 4.11984 6 5.8 6H16.2C17.8802 6 18.7202 6 19.362 6.32698C19.9265 6.6146 20.3854 7.07354 20.673 7.63803C21 8.27976 21 9.11984 21 10.8V13C21 13.93 21 14.395 20.8978 14.7765C20.6204 15.8117 19.8117 16.6204 18.7765 16.8978C18.395 17 17.93 17 17 17M14 9.5H17M8.2 21H13.8C14.9201 21 15.4802 21 15.908 20.782C16.2843 20.5903 16.5903 20.2843 16.782 19.908C17 19.4802 17 18.9201 17 17.8V16.2C17 15.0799 17 14.5198 16.782 14.092C16.5903 13.7157 16.2843 13.4097 15.908 13.218C15.4802 13 14.9201 13 13.8 13H8.2C7.07989 13 6.51984 13 6.09202 13.218C5.71569 13.4097 5.40973 13.7157 5.21799 14.092C5 14.5198 5 15.0799 5 16.2V17.8C5 18.9201 5 19.4802 5.21799 19.908C5.40973 20.2843 5.71569 20.5903 6.09202 20.782C6.51984 21 7.0799 21 8.2 21Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Printing;
